import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const CustomHeader = () => {
  const { currentUser, logout } = useAuth();

  return (
    <header className="bg-gray-800 text-white shadow-md">
      <div className="container mx-auto px-4 py-4 flex flex-wrap items-center justify-between">
        <div className="flex items-center">
          <Link to="/" className="text-xl font-bold">Metrics Explorer</Link>
        </div>
        
        <nav className="flex items-center">
          <ul className="flex space-x-6">
            <li><Link to="/" className="hover:text-blue-300">Home</Link></li>
            <li><Link to="/stats" className="hover:text-blue-300">Stats</Link></li>
            <li><Link to="/health" className="hover:text-blue-300">Health</Link></li>
            <li><Link to="/pricing" className="hover:text-blue-300">Pricing</Link></li>
          </ul>
        </nav>
        
        <div className="flex items-center space-x-4 ml-6">
          {currentUser ? (
            <>
              <Link to="/profile" className="hover:text-blue-300">Profile</Link>
              <button 
                onClick={logout} 
                className="bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded"
              >
                Logout
              </button>
            </>
          ) : (
            <>
              <Link 
                to="/login" 
                className="hover:text-blue-300"
              >
                Login
              </Link>
              <Link 
                to="/register" 
                className="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded"
              >
                Register
              </Link>
            </>
          )}
        </div>
      </div>
    </header>
  );
};

export default CustomHeader;
